export default __webpack_public_path__ + "static/media/Vinay Kumar.273d6860.jpg";